"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIncrementPercentage = void 0;
const getIncrementPercentage = (a, b) => {
    if (a === null || b === null) {
        return null;
    }
    const normalizedA = Math.max(0, a);
    const normalizedB = Math.max(0, b);
    if (normalizedA === 0 || normalizedB === 0) {
        if (normalizedA > 0) {
            return 100;
        }
        else if (normalizedB > 0) {
            return -100;
        }
        else {
            return 0;
        }
    }
    return (100 * (normalizedA - normalizedB)) / normalizedB;
};
exports.getIncrementPercentage = getIncrementPercentage;
//# sourceMappingURL=get-increment-percentage.js.map